module.exports = __webpack_public_path__ + "media/app/img/windows-logo-cfb1d50d18312647741c87eb9a9a6e79.png";